import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import AdjustmentForm from "components/Adjustment/form"
import {
  getAdjustmentById,
  updateAdjustment,
} from "store/adjustment/adjustment-action"
import { getProviderItemCategories } from "store/provider-dashboard/provider-dashboard-action"
import { getProviderInAvailableItems } from "store/provider-in/provider-in-action"

const EditAdjustment = () => {
  return <h1>No allowed</h1>
  document.title = "Edit Adjustment"
  const params = useParams()
  const { id } = params
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, error, adjustment } = useSelector(state => state.adjustment)
  const items = useSelector(state => state.providerIn.items)
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  const handleSubmit = (values, file) => {
    const formData = new FormData()
    formData.append("_method", "put")
    Object.keys(values).forEach(k => formData.append(k, values[k]))
    if (file) formData.append("document", file)
    dispatch(updateAdjustment(id, formData, navigate))
  }

  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getAdjustmentById(id))
  }, [])

  useEffect(() => {
    if (adjustment?.item_category_id) {
      dispatch(
        getProviderInAvailableItems({
          item_category_id: adjustment.item_category_id,
        })
      )
    }
  }, [adjustment?.item_category_id])

  return (
    <AdjustmentForm
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      formMode={"Edit"}
      categories={categories?.data}
      distribution={adjustment}
      items={items?.data || []}
    />
  )
}

export default EditAdjustment
